import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { canUseCrm, isCrmBlocked } from '../config/crm';
import ComingSoon from '../pages/ComingSoon';

// Shows the CRM page only when the beta gate allows it. Blocked users (Amanda) go to the dashboard with no hint
// the section exists; anyone else outside the beta sees Coming soon.
export const crmIdentity = ({ user, viewAsUser }) => ({ uid: viewAsUser ? (viewAsUser.uid || viewAsUser.id || '') : user?.uid, email: viewAsUser ? viewAsUser.email : user?.email });
export default function CrmGate({ children }) {
  const auth = useAuth();
  const { uid, email } = crmIdentity(auth);
  if (isCrmBlocked(auth.userRole, uid, email)) return <Navigate to="/dashboard" replace />;
  return canUseCrm(auth.userRole, uid, email) ? children : <ComingSoon title="My Leads" />;
}
